<div class="saved-lives">
  <div *ngIf="config?.upperLabel" class="upper-label">{{config?.upperLabel}}</div>
  <div class="warpper-icon">
    <i class="icon-heartfilled"></i> <span class="lives-count">{{config?.childCount}}</span>
  </div>
  <div class="lives-text">{{config?.label}}</div>
</div>